import ImagesSampleAuth1Png from '@/public/images/sample-auth/1.png';
import ImagesSampleAuth2Png from '@/public/images/sample-auth/2.png';
import ImagesSampleAuth3Png from '@/public/images/sample-auth/3.png';
import ImagesSampleAuth4Png from '@/public/images/sample-auth/4.png';
import ImagesSampleAuth5Png from '@/public/images/sample-auth/5.png';
import ImagesSampleAuth6Png from '@/public/images/sample-auth/6.png';
import ImagesSampleAuth7Png from '@/public/images/sample-auth/7.png';
import ImagesSampleAuth8Png from '@/public/images/sample-auth/8.png';
import ImagesSampleAuth9Png from '@/public/images/sample-auth/9.png';

export {
  ImagesSampleAuth1Png,
  ImagesSampleAuth2Png,
  ImagesSampleAuth3Png,
  ImagesSampleAuth4Png,
  ImagesSampleAuth5Png,
  ImagesSampleAuth6Png,
  ImagesSampleAuth7Png,
  ImagesSampleAuth8Png,
  ImagesSampleAuth9Png,
};
